import axios, { isCancel as isCancelRequest } from 'axios';
import qs from 'qs';

const csrfTokenElement = document.querySelector('meta[name=csrf-token]');
const csrfToken = csrfTokenElement ? csrfTokenElement.content : '';

axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
axios.defaults.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'brackets' });

const buildRequestCancelation = () => {
  let cancelTokens = {};

  const getCancelToken = (tokenName, { sideCancelation = [] } = {}) => {
    [tokenName, ...sideCancelation].forEach((name) => {
      if (cancelTokens[name]) cancelTokens[name].cancel();
    });

    cancelTokens[tokenName] = axios.CancelToken.source();
    return cancelTokens[tokenName];
  };

  const cleanup = () => {
    Object.keys(cancelTokens).forEach((key) => {
      if (cancelTokens[key]) cancelTokens[key].cancel();
    });

    cancelTokens = {};
  };

  return {
    getCancelToken,
    cleanup,
  };
};

export { csrfToken, isCancelRequest, buildRequestCancelation };

export default axios;
